import DashBoardCard from './DashBoardCard'

import DashBoardTable from './DashBoardTable'

const Dashboard = () => {
  return (
    <>
      <p className='is-size-4 has-text-weight-bold mb-1'>Dashboard</p>
      <div className=""><DashBoardCard /></div>
      <div className="columns">


      </div>
      <div className=""><DashBoardTable /></div>
    </>
  )
}

export default Dashboard
